import { useLayoutEffect, useState } from "react";
import { resolveWorkspacePanelLayout } from "../rightPanelLayout";

export function useWorkspacePanelLayout() {
  const [workspace, workspaceRef] = useState<HTMLDivElement | null>(null);
  const [availableWidth, setAvailableWidth] = useState(0);
  useLayoutEffect(() => {
    if (!workspace) return;
    const measure = () => setAvailableWidth(workspace.clientWidth);
    measure();
    if (typeof ResizeObserver === "undefined") {
      window.addEventListener("resize", measure);
      return () => window.removeEventListener("resize", measure);
    }
    const observer = new ResizeObserver(measure);
    observer.observe(workspace);
    return () => observer.disconnect();
  }, [workspace]);
  return { workspaceRef, ...resolveWorkspacePanelLayout(availableWidth) };
}
